const { registerBlockType } = wp.blocks;
const { RichText, InnerBlocks, URLInputButton } = wp.blockEditor;
const { Fragment } = wp.element;
const { Button, Icon, PanelBody, ToggleControl } = wp.components;
const { InspectorControls, useBlockProps } = wp.blockEditor;
const { __ } = wp.i18n;

import PgButton from '../utils/pg-button';

const ALLOWED_BLOCKS = ['core/paragraph'];

const BlockEdit = ({ attributes, setAttributes }) => {
  const { intro, paragraphs, buttons } = attributes;

  const addParagraph = () => {
    const newParagraphs = [
      ...paragraphs,
      ...[`New paragraph #${paragraphs.length}`],
    ];
    setAttributes({ paragraphs: newParagraphs });
  };

  const removeParagraph = (index) => {
    const newParagraphs = paragraphs.filter((_, i) => i !== index);
    setAttributes({ paragraphs: newParagraphs });
  };

  const addButton = () => {
    const newButtons = [
      ...buttons,
      {
        link: '',
        label: 'New Button',
        buttonClass: `btn btn-dark btn-outline`,
      },
    ];
    setAttributes({ buttons: newButtons });
  };

  const removeButton = (index) => {
    const newButtons = buttons.filter((_, i) => i !== index);
    setAttributes({ buttons: newButtons });
  };

  const updateButton = (index, updates) => {
    const newButtons = buttons.map((button, i) => {
      if (i === index) {
        return { ...button, ...updates };
      }
      return button;
    });
    setAttributes({ buttons: newButtons });
  };

  return (
    <Fragment>
      <section className={'section-light-primary'}>
        <div className={'home-top-section'}>
          <RichText
            tagName="h1"
            value={intro}
            onChange={(intro) => setAttributes({ intro: intro })}
            placeholder={__('Your header...')}
          />
          {paragraphs.map((paragraph, index) => (
            <>
              <RichText
                tagName="p"
                value={paragraph}
                onChange={(newContent) => {
                  const newParagraphs = paragraphs.slice();
                  newParagraphs[index] = newContent;
                  setAttributes({ paragraphs: newParagraphs });
                }}
                placeholder={`Paragraph ${index + 1}`}
              />
              <Button
                isSmall
                onClick={() => removeParagraph(index)}
                className="remove-paragraph-button"
              >
                <Icon icon="no-alt" /> Remove Paragraph
              </Button>
            </>
          ))}
          <Button isPrimary onClick={addParagraph}>
            + Add Paragraph
          </Button>
          <p className="buttons">
            {buttons.map((button, index) => (
              <div key={`btnIdx-${index}`}>
                <PgButton
                  link={button.link}
                  label={button.label}
                  buttonClass={button.buttonClass}
                  onUpdate={(object) => updateButton(index, object)}
                  onRemove={() => removeButton(index)}
                />
              </div>
            ))}
          </p>
          <Button isSecondary onClick={addButton}>
            + Add Button
          </Button>
        </div>
      </section>
    </Fragment>
  );
};

registerBlockType('pg/hero-top', {
  title: 'PG Hero Top',
  icon: 'smiley',
  category: 'layout',
  supports: {
    align: true,
    html: false,
  },
  attributes: {
    intro: {
      type: 'string',
      source: 'html',
      selector: 'h1',
      default:
        'From compliance to sustainable impact, we help you grow your business.',
    },
    paragraphs: {
      type: 'array',
      default: ['New paragraph #1'],
    },
    buttons: {
      type: 'array',
      default: [],
      source: 'query',
      selector: 'p.buttons a',
      query: {
        link: {
          type: 'string',
          source: 'attribute',
          attribute: 'href',
        },
        label: {
          type: 'string',
          source: 'text',
        },
        buttonClass: {
          type: 'string',
          source: 'attribute',
          attribute: 'class',
        },
      },
    },
  },
  edit: BlockEdit,
  save: ({ attributes }) => {
    const { intro, paragraphs, buttons } = attributes;

    return (
      <section className={'section-light-primary'}>
        <div className={'home-top-section'}>
          <RichText.Content tagName="h1" value={intro} />
          {paragraphs.map((paragraph, index) => (
            <RichText.Content key={index} tagName="p" value={paragraph} />
          ))}
          <p className="buttons">
            {buttons.map((button, index) => (
              <a key={index} href={button.link} className={button.buttonClass}>
                {button.label}
              </a>
            ))}
          </p>
        </div>
      </section>
    );
  },
});
